import { render, staticRenderFns } from "./formMyTaskHt.vue?vue&type=template&id=137d80d0&"
import script from "./formMyTaskHt.vue?vue&type=script&lang=js&"
export * from "./formMyTaskHt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports